
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/news/category/[id]",
      function () {
        return require("private-next-pages/[lang]/news/category/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/news/category/[id]"])
      });
    }
  